import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fb-ang-lib',
  template: `
    <p>
      ang-lib works!
    </p>
  `,
  styles: []
})
export class AngLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
